import React, { useState, useCallback, useMemo, createContext, useContext, useEffect } from 'react';

const PaginationContext = createContext(null);

export const PaginationProvider = ({ children, initialShownPageIndex = 0 }) => {
  const [visitedPages, setVisitedPages] = useState([initialShownPageIndex]);
  const [shownPageIndex, setShownPageIndex] = useState(initialShownPageIndex);
  const [pageCount, setPageCount] = useState(null);

  useEffect(() => {
    setVisitedPages((current) =>
      current.includes(shownPageIndex) ? current : [...current, shownPageIndex],
    );
  }, [shownPageIndex]);

  const nextPage = useCallback(() => {
    setShownPageIndex((current) =>
      pageCount == null ? current + 1 : Math.min(current + 1, pageCount - 1),
    );
  }, [pageCount]);

  const previousPage = useCallback(() => {
    setShownPageIndex((current) => Math.max(current - 1, 0));
  }, []);

  const value = useMemo(() => ({
    shownPageIndex,
    setShownPageIndex,
    pageCount,
    setPageCount,
    nextPage,
    previousPage,
    visitedPages
  }), [shownPageIndex, pageCount, nextPage, previousPage]);

  return <PaginationContext.Provider value={value}>{children}</PaginationContext.Provider>;
};

export const PaginationBoundary = ({ children }) => {
  const context = useContext(PaginationContext);

  if (context) {
    return children;
  }

  return <PaginationProvider>{children}</PaginationProvider>;
};

export default PaginationContext;
